(() => {
  'use strict';
  if (customElements.get('prink-cart-discount')) return;
  let busy = false;
  const key = value => String(value || '').trim().toUpperCase();
  const codes = cart => {
    const explicit = Array.isArray(cart.discount_codes) ? cart.discount_codes.map(d => typeof d === 'string' ? d : d.code).filter(Boolean) : [];
    const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))];
    return [...new Set([...explicit, ...applications.filter(a => a?.type === 'discount_code').map(a => a.title).filter(Boolean)])];
  };
  const saved = (cart, code) => (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + (key(d.title) === key(code) ? Number(d.total_allocated_amount || 0) : 0), 0) + (cart.items || []).reduce((sum, item) => sum + (item.line_level_discount_allocations || []).reduce((amount, a) => amount + (key(a.discount_application?.title) === key(code) ? Number(a.amount || 0) : 0), 0), 0);
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.labels = JSON.parse(this.querySelector('[data-pw-discount-labels]').textContent);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-pw-discount-apply]')) this.update(false);
        if (event.target.closest('[data-pw-discount-remove]')) this.update(true);
      });
    }
    status(message, error = false) {
      const status = this.querySelector('[role="status"]');
      status.textContent = message;
      status.toggleAttribute('data-error', error);
    }
    async update(remove) {
      if (!remove && Date.now() >= Date.parse(this.dataset.expires)) { this.hidden = true; return; }
      if (busy) return;
      busy = true;
      const code = this.dataset.code, labels = this.labels, root = window.Shopify?.routes?.root || '/';
      const drawer = this.closest('cart-drawer');
      const sectionIds = drawer ? drawer.getSectionsToRender().map(s => s.id) : [];
      const controls = new Map();
      const setBusy = state => {
        document.querySelectorAll('prink-cart-discount button').forEach(b => b.disabled = state);
        if (state) {
          const scope = drawer || document;
          scope.querySelectorAll('button[name="checkout"], .quantity__button, [name="updates[]"]').forEach(control => {
            controls.set(control, control.disabled);
            control.disabled = true;
          });
        } else controls.forEach((disabled, control) => { if (control.isConnected) control.disabled = disabled; });
      };
      setBusy(true);
      this.status(remove ? labels.removing : labels.applying);
      const request = async discount => {
        const response = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({discount, ...(drawer ? {sections:sectionIds, sections_url:window.location.pathname} : {})})});
        const result = await response.json();
        if (!response.ok || result.status) throw Error(labels.error);
        return result;
      };
      try {
        const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw Error(labels.error);
        const before = await response.json();
        const existing = codes(before), others = existing.filter(c => key(c) !== key(code));
        if (!remove && others.length) { this.status(labels.conflict, true); return; }
        let data = await request(remove ? others.join(',') : [...new Set([...existing,code])].join(','));
        let rejected = !remove && (saved(data,code) <= 0 || Number(data.total_price) > Number(before.total_price));
        if (rejected) data = await request(existing.join(','));
        if (!drawer) {
          if (rejected) { this.status(labels.unavailable, true); return; }
          window.location.reload();
          return;
        }
        if (!data.sections || sectionIds.some(id => !data.sections[id])) {
          window.location.reload();
          return;
        }
        drawer.renderContents(data);
        document.dispatchEvent(new CustomEvent('pw:cart-total', {detail:data}));
        const next = drawer.querySelector('prink-cart-discount');
        if (rejected) next?.status(labels.unavailable, true);
        requestAnimationFrame(() => next?.querySelector('button')?.focus({preventScroll:true}));
      } catch (_) {
        this.status(labels.error, true);
      } finally {
        busy = false;
        setBusy(false);
      }
    }
  }
  customElements.define('prink-cart-discount',CartDiscount);
})();

